/* eslint-disable react/prop-types */
import React from 'react';
import T from 'i18n-react';
import { Box, Button, Modal, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import emailImage from 'assets/img/email.png';

const styles = {
  marginVertical: {
    margin: '20px 0 10px 0',
  },
  invalid: {
    color: '#f2f2f2',
  },
  dot: {
    verticalAlign: 'middle',
    fontSize: '1rem',
  },
  getStarted: {
    marginRight: '15px',
    marginTop: '20px',
    marginBotton: '20px',
  },
};

const PostRegistration = ({ email, open = false, onClose, onResend }) => (
  <Modal
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    open={open}>
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      style={{ background: '#fff', width: 420, padding: 40 }}>
      <img src={emailImage} alt='emailImage' />
      <Typography
        style={{
          fontWeight: 'bold',
          color: '#0C91C4',
          textAlign: 'center',
          fontSize: 36,
          marginTop: 15,
          marginBottom: 10,
        }}>
        {T.translate('registration.confirmEmailTitle')}
      </Typography>
      <Typography
        style={{
          textAlign: 'center',
        }}>
        {T.translate('registration.confirmEmailSubTitle1')}{' '}
        <Typography
          style={{
            display: 'inline-block',
            fontWeight: 'bold',
            color: '#0C91C4',
          }}>
          {email}
        </Typography>
        , {T.translate('registration.confirmEmailSubTitle2')}
      </Typography>
      <Button
        onClick={onClose}
        variant='contained'
        style={{
          width: '100%',
          marginTop: 60,
          background: '#0C91C4',
          color: '#fff',
        }}>
        {T.translate('registration.done')}
      </Button>
      <Button
        onClick={onResend}
        color='primary'
        style={{
          marginTop: 10,
          width: '100%',
        }}>
        {T.translate('registration.resend')}
      </Button>
    </Box>
  </Modal>
);

export default withStyles(styles)(PostRegistration);
